export const favoriteFilterKeys = {
	platformIds: 'favAdmSADPlatformIds',
	createdByIds: 'favAdmSADCreatedByIds',
}

export const reportStorageProps = {
	type: 'subaff-deals-v2',
	target: 'filters',
	tableSettingsTarget: 'table-settings',
	savedReportTarget: 'subaff-deals-v2-settings',
	savedReportFavoritesTarget: 'subaff-deals-v2-favorites',
	savedReportDefaultTarget: 'subaff-deals-v2-default',
	exceptions: ['sent_from', 'sent_to'],
	exceptionsIds: ['platformIds', 'createdByIds'],
	exceptionsStr: ['anid', 'playerId', 'source1', 'source2', 'source3', 'source4', 'source5'],
	maxFavoriteReports: 10,
}